import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import CalendarFilterWarning from './CalendarFilterWarning';
import { TextField, Box, Grid, Typography } from '@material-ui/core';
import { faker } from '@faker-js/faker';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
);
import useForms from '../../../../hooks/useForms';
import clsx from 'clsx';
/* CSS */
import useStyles from '../../Main.style';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import FinChart from './FinChart';

export const optionsForBarCharts = {
  responsive: true,
  plugins: {
    legend: {
      labels: {
        usePointStyle: true,
        boxWidth: 6,
      },
      position: 'bottom', //as const,
    },
    title: {
      display: true,
      text: '',
    },
  },
};
const labelsForFinancialProgression = ['Salary', 'Bonuses / Commissions'];

const FinancialProgressionTest = ({ userId }) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [filteredYearDataState, setFilteredYearDataState] = useState([]);
  const [isFormApprovalPending, setIsFormApprovalPending] = useState(false);
  const [reportEndDate, setReportEndDate] = useState(moment().format('MM-DD-YYYY'));
  const [reportStartDate, setReportStartDate] = useState(new Date('01-01-2019'));

  const [valueFrom, setValueFrom] = useState(reportStartDate.getFullYear());
  const [valueTo, setValueTo] = useState(reportStartDate.getFullYear() + 2);

  const [optionsFromState, setOptionsFromState] = useState([]);
  const [optionsToState, setOptionsToState] = useState([]);
  const [ddlFromStatus, setDdlFromStatus] = useState('');
  const [ddlToStatus, setDdlToStatus] = useState('');
  const [validationMessage, setValidationMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  let reportData = [];
  let totalMonths = { total: 0, flag: false };
  let rowTotal = { total: 0, flag: false };
  let columnTotal = [];
  let arrYear = [];
  let optionsFrom = [];
  let optionsTo = [];
  const fpDataSet = [];
  let dataForFinancialProgressionSales = {};
  const [pendingApprovalColumns, setPendingApprovalColumns] = useState([]);
  const [finalDataFPSales, setFinalDataFPSales] = useState({});
  const navigate = useNavigate();

  dataForFinancialProgressionSales = {
    labels: labelsForFinancialProgression,
    datasets: [
      {
        label: '2020',
        data: labelsForFinancialProgression.map(() =>
          faker.datatype.number({ min: 0, max: 400000 }),
        ),
        backgroundColor: '#A6CEE3',
      },
      {
        label: '2021',
        data: labelsForFinancialProgression.map(() =>
          faker.datatype.number({ min: 0, max: 400000 }),
        ),
        backgroundColor: '#1F78B4',
      },
      {
        label: '2022',
        data: labelsForFinancialProgression.map(() =>
          faker.datatype.number({ min: 0, max: 400000 }),
        ),
        backgroundColor: '#B2DF8A',
      },
    ],
  };

  if (Object.keys(finalDataFPSales).length > 0) {
    dataForFinancialProgressionSales.datasets = finalDataFPSales.datasets;
  }

  const sortOrderQuestions = [
    'Year',
    'Salary – total $ paid each year before taxes',
    'Benefits – total $ paid by VGL for healthcare',
    "Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions",
    "Other: Loan/Sales' Commissions",
  ];

  const { getFilteredAnswers, getFormYear } = useForms();
  let formYears = {};
  useEffect(() => {
    const fillReportData = async () => {
      userId == undefined ? (userId = loggedInUserData.id) : userId;
      if (userId !== null && userId !== undefined) {
        try {
          formYears = await getFormYear({
            userId: userId,
          });
          initializeFilters(formYears);
        } catch (e) {
          console.log(e);
        }
      }
    };
    fillReportData();
  }, [valueFrom, valueTo]);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleContinue = () => {
    fillFilteredReportByYear();
    setDialogOpen(false);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const initializeFilters = (formYears) => {
    setReportStartDate(
      new Date('01-01-' + formYears?.usersResult[0]?.minAnswer || formYears.minAnswer),
    );
    setReportEndDate(
      new Date('12-31-' + formYears?.usersResult[0]?.maxAnswer || formYears.maxAnswer),
    );

    for (
      var i = Number(formYears?.usersResult[0]?.minAnswer || formYears.minAnswer);
      i <= Number(formYears?.usersResult[0]?.maxAnswer || formYears.maxAnswer);
      i++
    ) {
      arrYear.push(i);
    }

    if (
      Number(formYears?.usersResult[0]?.minAnswer || formYears.minAnswer) > valueFrom &&
      Number(formYears?.usersResult[0]?.maxAnswer || formYears.maxAnswer) > valueTo
    ) {
      setValueFrom(Number(formYears?.usersResult[0]?.minAnswer || formYears.minAnswer));
      setValueTo(Number(formYears?.usersResult[0]?.maxAnswer || formYears.maxAnswer));
      validationOfFilters(Number(formYears.minAnswer), Number(formYears.maxAnswer));
    } else {
      validationOfFilters(valueFrom, valueTo);
    }

    fillYearRangeList(arrYear);
  };

  const validationOfFilters = (_valueFrom, _valueTo) => {
    if (_valueFrom && _valueTo) {
      if (Number(_valueTo) - Number(_valueFrom) >= 3) {
        // handle validation error
        setValidationMessage(
          'A range of more than 3 years can be selected, however it might affect loading time.',
        );
        handleOpenDialog();
      } else {
        fillFilteredReportByYear();
      }
    }
  };

  function excelDivideAndRound(a, b) {
    let result = (a / b).toFixed(2);
    let multiplier = Math.pow(10, 14);
    result = Math.round(result * multiplier) / multiplier;
    return result;
  }

  const getTotal = () => {
    return columnTotal.reduce((partialSum, a) => partialSum + a, 0).toFixed(2);
  };

  useEffect(() => {
    fillYearData();
  });

  useEffect(() => {
    if (formYears?.usersResult !== undefined) {
      initializeFilters();
    }
  }, [formYears]);
  const fillFilteredReportByYear = async () => {
    if (valueFrom && valueTo) {
      if (Number(valueTo) - Number(valueFrom) >= 3) {
        // handle validation error
        setValidationMessage(
          'A range of more than 3 years can be selected, however it might affect loading time.',
        );
      }

      // handle valid input
      let formResponse = await getFilteredAnswers({
        userId: userId || loggedInUserData.id,
        formType: 'ddfece0c-32fa-4658-8cbe-9d09cc92740f',
        startYear: Number(valueFrom),
        endYear: Number(valueTo),
      });

      if (formResponse?.usersResult !== undefined && formResponse?.usersResult !== null) {
        const reponseByYear = Object.values(
          formResponse?.usersResult.reduce((acc, obj) => {
            const key = obj.formTrackerId;
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
          }, {}),
        );

        let formValues = {};
        reponseByYear.map((year) => {
          let otherAmount = 0;
          year.map((ans) => {
            let questionText = ans?.questionDetails?.text;
            if (
              questionText ===
              "Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions"
            ) {
              formValues[questionText] =
                Number(ans?.answer) + Number(otherAmount ? otherAmount : 0);
            } else if (questionText === "Other: Loan/Sales' Commissions") {
              otherAmount = ans?.answer ? ans?.answer : '';
            } else {
              formValues[questionText] = ans?.answer ? ans?.answer : '';
            }
          });

          formValues['completeStatus'] = year[0]?.formTrackerDetails?.completeStatus;
          reportData.push(formValues);
          formValues = {};
        });

        fillReportFromDB();
        fillChartDataForFP();
      }
    }
  };

  const getRandomColor = () => {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
  const fillChartDataForFP = () => {
    const bgColorArr = ['#A6CEE3', '#1F78B4', '#B2DF8A', '#3A87F5', '#56A6C9'];

    reportData.map((elem, i) => {
      let objYear = {};
      objYear['label'] = elem['Year'];

      objYear['data'] = [
        Number(elem['Salary – total $ paid each year before taxes']),
        // Number(elem['Benefits – total $ paid by VGL for healthcare']),
        Number(elem["Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions"]),
        // Number(elem["Other: Loan/Sales' Commissions"]),
      ];
      objYear['backgroundColor'] = bgColorArr[i] || getRandomColor();
      fpDataSet.push(objYear);
    });
    dataForFinancialProgressionSales['datasets'] = fpDataSet;
    setFinalDataFPSales(dataForFinancialProgressionSales);
  };
  const fillReportFromDB = () => {
    if (reportData.length > 0) {
      filterReportState(reportData, valueFrom, valueTo);
    }
  };

  const fillYearRangeList = (_arrYear) => {
    _arrYear.map((val, index) => {
      optionsFrom.push({ label: val.toString(), value: index });
      optionsTo.push({ label: val.toString(), value: index });
    });

    optionsFrom = optionsFrom.sort((a, b) => a['label'] - b['label']);
    setOptionsFromState(optionsFrom);
    optionsTo = optionsTo.sort((a, b) => a['label'] - b['label']);
    setOptionsToState(optionsTo);

    setDdlFromStatus(valueFrom);
    setDdlToStatus(valueTo);
  };

  const fillColumnData = (data) => {
    let questionArray = [];
    if (filteredYearDataState?.length > 0) {
      columnTotal = new Array(filteredYearDataState?.length).fill(0);
    }
    if (data !== undefined && data !== null && Object.entries(data).length !== 0) {
      data.forEach((k, index) => {
        if (index === 0) {
          for (const [key] of Object.entries(k)) {
            if (
              !(
                `${key}` === 'Name' ||
                `${key}` === 'Period (Start Year)' ||
                `${key}` === 'Start date' ||
                `${key}` === 'Benefits – total $ paid by VGL for healthcare'
              )
            ) {
              questionArray.push(`${key}`);
            }
          }
        }
      });
    }
    return questionArray;
  };

  const fillYearData = (year, finParam) => {
    let finObjArr = [];
    finObjArr = { ...filteredYearDataState };

    for (const [value] of Object.entries(finObjArr)) {
      if (value['Year'] == year) {
        return value[finParam];
      }
    }
  };

  const monthsWorked = (sDate, d1) => {
    let startDate = new Date(d1.getFullYear(), 0, 1);

    let endDate =
      d1.getFullYear().toString() === new Date().getFullYear().toString()
        ? new Date(d1.getFullYear(), new Date().getMonth() - 1, new Date().getDate())
        : new Date(d1.getFullYear(), 11, 31);

    if (moment(sDate) >= moment(reportStartDate)) {
      if (getMonthDifference(sDate, endDate) < 0) {
        return 0;
      } else {
        if (endDate > reportEndDate) {
          endDate = reportEndDate;
          return getMonthDifference(startDate, endDate);
        } else {
          if (sDate.getFullYear() == endDate.getFullYear()) {
            return getMonthDifference(sDate, endDate);
          } else {
            return getMonthDifference(startDate, endDate);
          }
        }
      }
    } else if (moment(sDate) < moment(reportStartDate)) {
      startDate = d1;
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate = new Date(d1.getFullYear(), 11, 31);
      endDate.setHours(0);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      if (endDate > reportEndDate) {
        endDate = reportEndDate;

        return getMonthDifference(startDate, endDate);
      } else {
        return getMonthDifference(startDate, endDate);
      }
    }
  };

  function getMonthDifference(startDate, endDate) {
    let adjustedEndDate = moment(endDate);

    if (
      startDate.getMonth() !== endDate.getMonth() ||
      startDate.getFullYear() !== endDate.getFullYear()
    ) {
      adjustedEndDate = moment(endDate).endOf('month');
    }

    const diffInMonths = adjustedEndDate.diff(moment(startDate), 'months', true);

    if (diffInMonths % 1 > 0.9) {
      // Difference is a whole number of months

      return Math.ceil(diffInMonths);
    } else {
      // Difference is not a whole number of months
      const fullMonths = Math.floor(diffInMonths);
      const remainingDays = moment(adjustedEndDate).diff(
        moment(startDate).add(fullMonths, 'months'),
        'days',
      );
      const daysInMonth = moment(adjustedEndDate).daysInMonth();
      const result = fullMonths + remainingDays / daysInMonth;
      return result.toFixed(2);
    }
  }

  const columnData = fillColumnData(filteredYearDataState);

  const filterReportState = (_reportData, startYear, endYear) => {
    setFilteredYearDataState(
      _reportData
        .sort((a, b) => new Date(a.Year) - new Date(b.Year))
        .filter((elem, i) => {
          if (elem?.completeStatus === 0 && Number(elem?.Year) < Number(moment().format('YYYY'))) {
            setIsFormApprovalPending(true);
            setPendingApprovalColumns([...pendingApprovalColumns, i]);
          }
          return Number(elem?.Year) >= startYear && Number(elem?.Year) <= endYear;
        }),
    );
  };

  return (
    <>
      <If condition={validationMessage !== ''}>
        <CalendarFilterWarning
          open={dialogOpen}
          onContinue={handleContinue}
          onClose={handleCloseDialog}
          onOpen={handleOpenDialog}
          warning={validationMessage}
        />
      </If>

      <Box>
        <If condition={filteredYearDataState.length > 0}>
          <Grid container spacing={1}>
            <Grid item xs={12} align="center">
              {isFormApprovalPending && (
                <Typography
                  variant="body1"
                  className={(classes.colleft, classes.PendingApprovalLegend)}
                >
                  * You have a document waiting for your approval,{' '}
                  <a
                    color="textPrimary"
                    href="javascript:;"
                    onClick={() => {
                      navigate('/app/forms/:id');
                    }}
                  >
                    Click here.
                  </a>
                </Typography>
              )}

              <Typography variant="h2">
                Financial Progression while working with OA Ventures
              </Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Box mb={3}>
                <Typography variant="h4">Executive Summary</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12} sm={6} style={{ textTransform: 'uppercase' }}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item style={{ width: '100px' }}>
                        <Typography variant="subtitle1">Name:</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body1">
                          {filteredYearDataState.length > 0 && filteredYearDataState[0]['Name']}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container></Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item style={{ width: '100px' }}>
                        <Typography variant="subtitle1">Start Date:</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body1">
                          {filteredYearDataState.length > 0 &&
                            moment(filteredYearDataState[0]['Start date']).format('DD MMMM YYYY')}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} align="right">
                  <Grid item xs={12}>
                    {/* <Grid container justifyContent="space-between" alignItems="center">
                      <Grid item xs={4} align="right"> */}
                    <Formik
                      initialValues={{
                        yearRange: '',
                      }}
                    >
                      {({}) => {
                        return (
                          <Box mt={{ xs: 2, sm: 0, md: 0 }}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={8}
                              className={classes.FinancialProgressionDateFilter}
                              align="left"
                            >
                              <Grid container spacing={2}>
                                {/* Filter Code Comments */}
                                <Grid item xs={6}>
                                  <label>From</label>
                                  <Autocomplete
                                    options={optionsFromState}
                                    disableClearable
                                    getOptionLabel={(option) => option?.label || ''}
                                    getOptionDisabled={(option) => valueTo < option.label}
                                    value={valueFrom}
                                    onChange={(event, newValue) => {
                                      const selectedValue = Number(newValue?.label);
                                      if (valueFrom !== selectedValue) {
                                        setValueFrom(selectedValue);
                                        setDdlFromStatus('');
                                        validationOfFilters(selectedValue, valueTo);
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={ddlFromStatus}
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <label>To</label>
                                  <Autocomplete
                                    options={optionsToState}
                                    disableClearable
                                    getOptionLabel={(option) => option?.label || ''}
                                    getOptionDisabled={(option) => valueFrom > option.label}
                                    value={valueTo}
                                    onChange={(event, newValue) => {
                                      const selectedValue = Number(newValue?.label);
                                      if (valueTo !== selectedValue) {
                                        setValueTo(selectedValue);
                                        setDdlToStatus('');
                                        validationOfFilters(valueFrom, selectedValue);
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={ddlToStatus}
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      }}
                    </Formik>
                    {/* </Grid>
                    </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                {/* Report Year wise */}
                <Box
                  mt={{ xs: 0, sm: 0, md: 3 }}
                  width={1}
                  className={classes.MonthsWorkedTableWrapper}
                >
                  <TableContainer component={Paper}>
                    <div className={classes.MonthsWorkedTableOuter}>
                      <div className={classes.MonthsWorkedTable}>
                        <table>
                          {/* Header column */}

                          <tr
                            className={classes.MonthsWorkedTableHead}
                            key={filteredYearDataState?.length}
                          >
                            <td className={classes.colleft} component="th" scope="row">
                              Number of months worked per year
                            </td>
                            {filteredYearDataState
                              .sort((a, b) => a['Year'] - b['Year'])
                              .map((header, i) => {
                                Number(
                                  (totalMonths.total += Number(
                                    monthsWorked(
                                      new Date(header['Start date']),
                                      new Date(header['Year']),
                                    ),
                                  )),
                                );
                                if (i == filteredYearDataState?.length - 1) {
                                  totalMonths.flag = true;
                                }
                                return (
                                  <td className={classes.colmiddle} key={i}>
                                    {monthsWorked(
                                      new Date(header['Start date']),
                                      new Date(header['Year']),
                                    )}{' '}
                                    {'months'}
                                  </td>
                                );
                              })}{' '}
                            {
                              <td className={classes.colright}>
                                Total of {totalMonths.flag && totalMonths.total.toFixed(2)} months
                              </td>
                            }
                          </tr>

                          {/* Financial figures columns */}
                          {/* <TableBody> */}
                          {columnData
                            .sort(
                              (a, b) =>
                                sortOrderQuestions.indexOf(a) - sortOrderQuestions.indexOf(b),
                            )
                            .map(
                              (row, rowIndex) =>
                                row !== 'completeStatus' && (
                                  <>
                                    <tr key={rowIndex}>
                                      <th
                                        className={classes.colleft}
                                        key={rowIndex}
                                        component="th"
                                        scope="row"
                                      >
                                        {row !== 'Year' ? (
                                          row ===
                                          "Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions" ? (
                                            <>
                                              {/* <strong>Bonuses</strong> */}
                                              {'Bonuses / Commissions'}
                                            </> // split the string and wrap the word "Bonuses" in a <strong> tag
                                          ) : row === "Other: Loan/Sales' Commissions" ? (
                                            <>
                                              <strong>Other</strong>
                                              {" - Loan/Sales' Commissions'"}
                                            </>
                                          ) : (
                                            row ===
                                              'Salary – total $ paid each year before taxes' && (
                                              <>
                                                {/* <strong>Salary</strong> */}
                                                {' Gross salary (before taxes)'}
                                              </>
                                            )
                                          )
                                        ) : (
                                          <span>&nbsp;</span>
                                        )}
                                      </th>
                                      {filteredYearDataState
                                        .sort((a, b) => a['Year'] - b['Year'])
                                        .map((obj, columnIndex) => {
                                          if (
                                            columnIndex == filteredYearDataState?.length - 1 &&
                                            filteredYearDataState?.length > 1
                                          ) {
                                            rowTotal.flag = true;
                                          } else {
                                            if (columnIndex == 0) {
                                              rowTotal.total = 0;
                                              rowTotal.flag = false;
                                            }
                                          }

                                          if (row !== 'Year') {
                                            rowTotal.total += Number(
                                              fillYearData(obj['Year'], row),
                                            );
                                            columnTotal[columnIndex] += Number(
                                              fillYearData(obj['Year'], row),
                                            );
                                          }

                                          return (
                                            <td
                                              className={clsx(
                                                classes.colmiddle,
                                                obj?.completeStatus
                                                  ? classes.classApproved
                                                  : obj['Year'] &&
                                                    obj['Year'] !==
                                                      new Date().getFullYear().toString()
                                                  ? classes.classPendingApproval
                                                  : classes.classApproved,
                                              )}
                                              key={columnIndex}
                                              component="th"
                                              scope="row"
                                            >
                                              {row == 'Year' ? (
                                                <b style={{ textDecoration: 'underline' }}>
                                                  {fillYearData(obj['Year'], row)}
                                                </b>
                                              ) : (
                                                '$ ' +
                                                Number(
                                                  fillYearData(obj['Year'], row),
                                                ).toLocaleString()
                                              )}
                                            </td>
                                          );
                                        })}
                                      {
                                        // Total column
                                        <td className={classes.colright} key={columnData?.length}>
                                          {row == 'Year' ? (
                                            <b style={{ fontWeight: '800' }}>Total USD</b>
                                          ) : (
                                            '$ ' + Number(rowTotal.total).toLocaleString()
                                          )}
                                        </td>
                                      }
                                    </tr>
                                  </>
                                ),
                            )}
                          <tr>
                            <th className={classes.colleft}>
                              <b>Total USD without Healthcare/Benefits</b>
                            </th>

                            {columnTotal.map((columnTotalVal, columnTotalIndex) => {
                              return (
                                <>
                                  <td className={clsx(classes.colmiddle)}>
                                    {pendingApprovalColumns.includes(columnTotalIndex) ? (
                                      <span className={classes.classPendingApproval}>
                                        $ {Number(columnTotalVal).toLocaleString()}
                                      </span>
                                    ) : (
                                      // <>$ {Number(columnTotalVal).toLocaleString()}</>
                                      <>$ {Number(columnTotalVal).toLocaleString()}</>
                                    )}
                                  </td>
                                  {columnTotalIndex == columnTotal.length - 1 && (
                                    <td className={classes.colright}>
                                      $ {Number(getTotal()).toLocaleString()}
                                    </td>
                                  )}
                                </>
                              );
                            })}
                          </tr>

                          <tr>
                            <th className={classes.colleft}>
                              Monthly Average % increase from previous year
                            </th>
                            {columnTotal.map((columnTotalVal, columnTotalIndex) => {
                              return (
                                <>
                                  {columnTotalIndex > 0 ? (
                                    <td className={classes.colmiddle}>
                                      {Number(columnTotal[columnTotalIndex - 1]) !== 0
                                        ? Math.round(
                                            (Number(
                                              columnTotalVal - columnTotal[columnTotalIndex - 1],
                                            ) /
                                              Number(columnTotal[columnTotalIndex - 1])) *
                                              100,
                                          ) + '%'
                                        : 'NA'}
                                    </td>
                                  ) : (
                                    <td className={classes.colmiddle}></td>
                                  )}
                                </>
                              );
                            })}
                            <td className={classes.colright}>
                              <span className={classes.fontweightlight}>
                                {' '}
                                {Number(columnTotal[0]) !== 0
                                  ? Math.round(
                                      (Math.pow(
                                        Number(
                                          columnTotal[columnTotal.length - 1] / columnTotal[0],
                                        ),
                                        1 / 3,
                                      ) -
                                        1) *
                                        100,
                                    ) + '% (CAGR)'
                                  : 'NA (CAGR)'}
                              </span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </TableContainer>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box className={classes.MonthsWorkedTableBottom}>
            <Box
              display="inline-flex"
              justifyContent="center"
              alignItems="center"
              flexDirection={{ xs: 'column', sm: 'row', md: 'row' }}
              mt={3}
              className={classes.AverageTotalDetail}
            >
              <Box px={2} py={1.5}>
                <b>
                  Average total benefits/payments per effective time (months) worked with Vector
                  Global Logistics:
                </b>
              </Box>
              <Box px={2} py={1.5} style={{ background: '#f2f5f8' }}>
                <b style={{ fontWeight: '800' }}>
                  {'$ '}
                  {totalMonths !== 0 &&
                    columnTotal !== 0 &&
                    excelDivideAndRound(
                      getTotal(),
                      Number(totalMonths.total),
                    ).toLocaleString()}{' '}
                </b>
              </Box>
            </Box>
            <Box display="flex" justifyContent="center" mt={3}>
              Please note this document is confidencial and for your reference only - This document
              has no legal value.
            </Box>
          </Box>
        </If>
        <If condition={filteredYearDataState.length === 0}>
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="body1">Report not available</Typography>
            </Grid>
          </Grid>
        </If>
      </Box>
      <Box>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <Box className={classes.innercontentWhite}>
                {/* <FinChart chartData={finalDataFPSales} /> */}

                <Bar options={optionsForBarCharts} data={dataForFinancialProgressionSales} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default FinancialProgressionTest;
